var path = '/client/front-office/modules/instance/views/partials/instance-block_name.html';
var html = "<a class=\"instance-block-name\"\n   ng-href=\"{{ vm.getLink() }}\"\n   target=\"_blank\">\n   {{ ::vm.instance.name }}\n</a>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;